import axios from 'axios'
import {BACKEND_HOST} from './index'
import Cookies from 'js-cookie'


// ---- 1) axios instance を作る ----
export const authAxios = axios.create({
  baseURL: BACKEND_HOST,
//  timeout: 60000,
});

// ---- 2) 毎回 Authorization を付与（Cookieのtokenを使う） ----
authAxios.interceptors.request.use((config) => {
  const token = Cookies.get("token");
  if (!token) {
    // ここで落とすと「なぜ403か」が一瞬で分かる
    throw new Error('JWT token is missing (Cookies.get("token") is empty)');
  }
  config.headers = config.headers || {};
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ---- 3) 認証不要 axios ----
export const publicAxios = axios.create({
  baseURL: BACKEND_HOST,
 // timeout: 60000,
});


/*********************
      Login page
*********************/
export const apiLoginUser = (email, password, token) =>
  publicAxios({
    method: 'POST',
    url: '/user/login',
    data: { email, password, token },
  })

/*********************
      Plans pages
*********************/
export const apiGetPlanDetails = (planId) =>
  authAxios({
    method: 'GET',
    url: `/asokoplus/plans/${planId}`,
  })

export const apiUpdatePlanInputs = (planId, inputs) =>
  authAxios({
    method: 'POST',
    url: `/asokoplus/plans/${planId}`,
    data: {
      inputs,
    },
  })

/*********************
      Users page
*********************/
export const apiGetAllUsers = () =>
  authAxios({
    method: 'GET',
    url: `/user/all`,
  })

export const apiGetUserFromId = (user_id) =>
  authAxios({
    method: 'GET',
    url: `/user/get-details/${user_id}`,
  })

export const apiGetUserFromCompanyId = (company_id) =>
  authAxios({
    method: 'GET',
    url: `/user/get-details/company-id/${company_id}`,
  })

export const apiCreateUser = ({
  email,
  password,
  lang,
  first_name,
  last_name,
  role,
  company_id,
  is_notification
}) =>
  authAxios({
    method: 'POST',
    url: '/user/create',
    data: {
      email,
      password,
      lang,
      first_name,
      last_name,
      role,
      company_id,
      is_notification
    },
  })

export const apiUpdateUserDetails = ({
  first_name,
  last_name,
  password,
  email,
  role,
  company_id,
  is_notification,
  user_id
}) =>
  authAxios({
    method: 'POST',
    url: `/user/update`,
    data: {
      first_name,
      last_name,
      password,
      email,
      role,
      company_id,
      is_notification,
      user_id
    },
  })

export const apiDeleteUser = ({ id }) =>
  authAxios({
    method: 'POST',
    url: `/user/delete`,
    data: { id },
  })

/*********************
      Companies page
*********************/
export const apiGetAllCompanies = () =>
  authAxios({
    method: 'GET',
    url: `/company/all`,
  })

export const apiCreateCompany = ({ name, short_name }) =>
  authAxios({
    method: 'POST',
    url: '/company/create',
    data: { name, short_name },
  })

export const apiGetCompanyFromId = (company_id) =>
  authAxios({
    method: 'GET',
    url: `/company/get-details/${company_id}`,
  })

export const apiUpdateCompanyDetails = ({ name, short_name, id }) =>
  authAxios({
    method: 'POST',
    url: `/company/update`,
    data: {
      name,
      short_name,
      id
    },
  })

export const apiDeleteCompany = ({ id }) =>
  authAxios({
    method: 'DELETE',
    url: `/company/delete`,
    data: { id },
  })

/*********************
      Warehouse page
*********************/
export const apiGetAllWarehouses = () =>
  authAxios({
    method: 'GET',
    url: `/warehouse/all`,
  })

export const apiCreateWarehouse = ({ name, short_name, company_id, limit_simulation_sec }) =>
  authAxios({
    method: 'POST',
    url: '/warehouse/create',
    data: { name, short_name, company_id, limit_simulation_sec },
  })

export const apiUpdateWarehouseDetails = ({
  name,
  short_name,
  company_id,
  limit_simulation_sec,
  id
}) =>
  authAxios({
    method: 'POST',
    url: `/warehouse/update`,
    data: {
      name,
      short_name,
      company_id,
      limit_simulation_sec,
      id
    },
  })

export const apiGetWarehouseFromId = (id) =>
  authAxios({
    method: 'GET',
    url: `/warehouse/get-details/warehouse-id/${id}`,
  })

export const apiGetWarehouseFromCompanyId = (company_id) =>
  authAxios({
    method: 'GET',
    url: `/warehouse/get-details/${company_id}`,
  })

export const apiDeleteWarehouse = ({ id }) =>
  authAxios({
    method: 'DELETE',
    url: `/warehouse/delete`,
    data: { id },
  })

/*********************
  Warehouse Assign
*********************/
export const apiCreateWarehouseAssign = ({ user_id, warehouse_id }) =>
  authAxios({
    method: 'POST',
    url: '/warehouse-assign/create',
    data: { user_id, warehouse_id },
  })

export const apiGetWarehouseAssignFromUserId = (userId) =>
  authAxios({
    method: 'GET',
    url: `/warehouse-assign/get-details/${userId}`,
  })

export const apiDeleteWarehouseAssignFromUserId = ({ user_id }) =>
  authAxios({
    method: 'DELETE',
    url: `/warehouse-assign/delete-user_id`,
    data: { user_id },
  })

export const apiUpdateWarehouseAssignFromUserId = ({user_id, warehouse_list}) =>
  authAxios({
    method: 'POST',
    url:`/warehouse-assign/update`,
    data: {user_id, warehouse_list},
  })

/*********************
      Asoko2 page
*********************/
// Simulation
export const apiGetAsoko2SimulationModels = (warehouse_id) =>
  authAxios({
    method: 'GET',
    url: `/asoko2/simulation/models/${warehouse_id}`,
  })

export const apiGetAsoko2SimulationMasters = (warehouse_id) =>
  authAxios({
    method: 'GET',
    url: `/asoko2/simulation/masters/${warehouse_id}`,
  })

  export const apiGetAsoko2SimulationResults = (warehouse_id, page = 1, pageSize = 100) =>
    authAxios({
      method: 'GET',
      url: `/asoko2/simulation/results/${warehouse_id}?page=${page}&pageSize=${pageSize}`,
    })

export const apiGetAsoko2SimulationResultsLastMod = (warehouse_id) =>
  authAxios({
    method: 'GET',
    url: `/asoko2/simulation/resultslastmod/${warehouse_id}`,
  })

export const apiAsoko2SimulationExec = ({ warehouse_id, account, userFirstName, userLastName, excelFlag }) =>
  authAxios({
    method: 'POST',
    url: `/asoko2/simulation/exec`,
    data: { warehouse_id, account, userFirstName, userLastName, excelFlag },
  })

export const apiAsoko2SimulationUpload = async (formData) => {
  await authAxios.post('/asoko2/simulation/upload', formData, {
    headers: {
        'Content-Type': 'multipart/form-data',
    },
  })
    .then((response) => {
      // console.log('アップロード成功', response.data)
    })
    .catch((error) => {
      // console.error('アップロード失敗', error)
    })
  }

// Picking フルモデル
export const apiGetAsoko2PickingModels = (warehouse_id) =>
  authAxios({
    method: 'GET',
    url: `/asoko2/picking/models/${warehouse_id}`,
  })

export const apiGetAsoko2PickingMasters = (warehouse_id) =>
  authAxios({
    method: 'GET',
    url: `/asoko2/picking/masters/${warehouse_id}`,
  })

export const apiGetAsoko2PickingResults = (warehouse_id, page = 1, pageSize = 100) =>
  authAxios({
    method: 'GET',
    url: `/asoko2/picking/results/${warehouse_id}?page=${page}&pageSize=${pageSize}`,
  })
  
export const apiAsoko2PickingExec = ({ warehouse_id, account, userFirstName, userLastName, excelFlag }) => {
  console.log('[apiAsoko2PickingExec] POST /asoko2/picking/exec')

  return authAxios({
    method: 'POST',
    url: `/asoko2/picking/exec`,
    data: { warehouse_id, account, userFirstName, userLastName, excelFlag },
  })
};



export const apiAsoko2PickingUpload = async (formData) => {
  await authAxios.post('/asoko2/picking/upload', formData, {
    headers: {
        'Content-Type': 'multipart/form-data',
    },
  })
    .then((response) => {
      console.log('アップロード成功', response.data)
    })
    .catch((error) => {
      console.error('アップロード失敗', error)
    })
  }

// Picking 汎用モデル
export const apiGetAsoko2PickingGeneralModels = (warehouse_id) =>
  authAxios({
    method: 'GET',
    url: `/asoko2/pickinggeneral/models/${warehouse_id}`,
  })

export const apiGetAsoko2PickingGeneralLocation = (warehouse_id) =>
  authAxios({
    method: 'GET',
    url: `/asoko2/pickinggeneral/location/${warehouse_id}`,
  })

export const apiGetAsoko2PickingGeneralMasters = (warehouse_id) =>
  authAxios({
    method: 'GET',
    url: `/asoko2/pickinggeneral/masters/${warehouse_id}`,
  })

export const apiGetAsoko2PickingGeneralResults = (warehouse_id, page = 1, pageSize = 100) =>
  authAxios({
    method: 'GET',
    url: `/asoko2/pickinggeneral/results/${warehouse_id}?page=${page}&pageSize=${pageSize}`,
  })


export const apiAsoko2PickingGeneralExec = ({ warehouse_id, account, userFirstName, userLastName, excelFlag }) => {
  console.log('[apiAsoko2PickingGeneralExec] POST /asoko2/pickinggeneral/exec')

  return authAxios({
    method: 'POST',
    url: `/asoko2/pickinggeneral/exec`,
    data: { warehouse_id, account, userFirstName, userLastName, excelFlag },
  });
};

export const apiAsoko2PickingGeneralUpload = async (formData) => {
  await authAxios.post('/asoko2/pickinggeneral/upload', formData, {
    headers: {
        'Content-Type': 'multipart/form-data',
    },
  })
    .then((response) => {
      console.log('アップロード成功', response.data)
    })
    .catch((error) => {
      console.error('アップロード失敗', error)
    })
  }

// Job Statusを取得
  export const apiGetAsoko2jobStatus = (job_id) => {
  console.log('[api JobStatus] GET /asoko2/getjobstatus/', { job_id });

  return authAxios({
    method: 'GET',
    url: `/asoko2/getjobstatus/${job_id}`,
  });
  };

